(function(){
     'use strict';

     angular
        .module('appback')
        .factory('UsuarioService', UsuarioService);

    UsuarioService.$inject = ['$http'];

    function UsuarioService($http){

        var service= {
           getUserInfo:getUserInfo,
           saveUser:saveUser,
           getEvaluacion:getEvaluacion
        };

        return service;

        function getUserInfo(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/usuario/getuserinfo', {  params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function saveUser(user,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               user:JSON.stringify(user)
            });
            $http.post('/backend/usuario/edituserinfo', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getEvaluacion(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/usuario/getevaluacion', {  params : { id : id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
      
    }
})();